/** @jsx jsx */
import { jsx } from "@emotion/core"
import { Avatar } from "@cd2/components/build/es6"
import { IRecord } from "../../../types/schema"
import { initials } from "../../../utils/string"

export function EmployeeAvatar({
  employee,
  size = 32,
}: {
  employee?: IRecord<"employees", "firstName" | "lastName"> | null
  size?: number
}) {
  return (
    <Avatar
      content={
        employee ? { text: initials(employee.firstName, employee.lastName) } : { icon: "user" }
      }
      color={employee ? "black" : "red"}
      size={size}
    />
  )
}
